import { getSwapValue } from './factories';

export const getSwapCurrency1 = getSwapValue('currency1');
export const getSwapCurrency2 = getSwapValue('currency2');
